import {
    HttpHandler,
    HttpRequest,
    HttpEvent,
    HttpInterceptor
} from "@angular/common/http";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { finalize, takeUntil } from "rxjs/operators";
import { EncryptionService } from "../../dashboard/services/encryption.service";
// import { HttpCancelService } from "../../shared/services/http-cancel/http-cancel.service";

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
    service_count = 0;
    constructor(
        private loaderService: NgxUiLoaderService,
        private _encryptionServie: EncryptionService,
        // private httpCancelService: HttpCancelService
        ) {
    }

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        let newRequest: HttpRequest<any>;
        this.service_count++;
        if (request.headers.get('skipLoader')) {
            const newHeaders = request.headers.delete('skipLoader');
            newRequest = request.clone({ headers: newHeaders });
        } else {
            this.loaderService.start();
            newRequest = request;
        }
        // const req = request.url.includes('getUserRolewithGID') ? request : this._encryptionServie.convertText('encrypt', request)
        return next.handle(this._encryptionServie.convertText('encrypt', request)).pipe(
            // takeUntil(this.httpCancelService.onCancelPendingRequests()),
            finalize(() => {
                this.service_count--;
                if (this.service_count == 0) {
                    this.loaderService.stop();
                }
            })
        );
    }
}
